import styled from 'styled-components'

import {
  _L_Normal,
  _S_Normal,
  desktopMediaQuery,
  ellipsis,
  mainColors,
} from '@avantstay/backoffice-core'

import Link from '@sharedComponents/Link'

export const BookingDetailMobile = styled(Link)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  flex: 1;

  &:hover {
    text-decoration: none;
  }
`

export const BookingDetail = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr 150px;
  gap: 20px;
  flex: 1;
`

export const BookingDetailColumn = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 5px;
  overflow: auto;

  ${desktopMediaQuery`
    margin-bottom: 0;
  `}
`

export const BookingPaymentColumn = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 5px;
  overflow: auto;

  ${desktopMediaQuery`
    margin-bottom: 0;
  `}
`

export const DetailTitle = styled.h3`
  ${_L_Normal};
  color: ${mainColors.black};
  margin-bottom: 2px;
  ${ellipsis};
`

export const DetailSubtitle = styled.h5`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark};
  ${ellipsis};
`
